// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ActiveWhen } from "./active-when";

/**
 * One LN2 member whose `active` is a predicate of the value.
 */
export class FlagRule implements flatbuffers.IUnpackableObject<FlagRuleT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FlagRule {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFlagRule(bb: flatbuffers.ByteBuffer, obj?: FlagRule): FlagRule {
    return (obj || new FlagRule()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsFlagRule(bb: flatbuffers.ByteBuffer, obj?: FlagRule): FlagRule {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FlagRule()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  template(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  activeWhen(): ActiveWhen {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ActiveWhen.NonZero;
  }

  values(index: number): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readInt64(this.bb!.__vector(this.bb_pos + offset) + index * 8) : 0n;
  }

  valuesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  validValues(index: number): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readInt64(this.bb!.__vector(this.bb_pos + offset) + index * 8) : 0n;
  }

  validValuesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startFlagRule(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addTemplate(builder: flatbuffers.Builder, template: number) {
    builder.addFieldInt32(0, template, 0);
  }

  static addActiveWhen(builder: flatbuffers.Builder, activeWhen: ActiveWhen) {
    builder.addFieldInt8(1, activeWhen, ActiveWhen.NonZero);
  }

  static addValues(builder: flatbuffers.Builder, valuesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, valuesOffset, 0);
  }

  static createValuesVector(builder: flatbuffers.Builder, data: bigint[]): flatbuffers.Offset {
    builder.startVector(8, data.length, 8);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt64(data[i]!);
    }
    return builder.endVector();
  }

  static startValuesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 8);
  }

  static addValidValues(builder: flatbuffers.Builder, validValuesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, validValuesOffset, 0);
  }

  static createValidValuesVector(builder: flatbuffers.Builder, data: bigint[]): flatbuffers.Offset {
    builder.startVector(8, data.length, 8);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt64(data[i]!);
    }
    return builder.endVector();
  }

  static startValidValuesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 8);
  }

  static endFlagRule(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createFlagRule(
    builder: flatbuffers.Builder,
    template: number,
    activeWhen: ActiveWhen,
    valuesOffset: flatbuffers.Offset,
    validValuesOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    FlagRule.startFlagRule(builder);
    FlagRule.addTemplate(builder, template);
    FlagRule.addActiveWhen(builder, activeWhen);
    FlagRule.addValues(builder, valuesOffset);
    FlagRule.addValidValues(builder, validValuesOffset);
    return FlagRule.endFlagRule(builder);
  }

  unpack(): FlagRuleT {
    return new FlagRuleT(
      this.template(),
      this.activeWhen(),
      this.bb!.createScalarList<bigint>(this.values.bind(this), this.valuesLength()),
      this.bb!.createScalarList<bigint>(this.validValues.bind(this), this.validValuesLength()),
    );
  }

  unpackTo(_o: FlagRuleT): void {
    _o.template = this.template();
    _o.activeWhen = this.activeWhen();
    _o.values = this.bb!.createScalarList<bigint>(this.values.bind(this), this.valuesLength());
    _o.validValues = this.bb!.createScalarList<bigint>(
      this.validValues.bind(this),
      this.validValuesLength(),
    );
  }

  unpackFields(...fields: string[]): FlagRuleT {
    const t = new FlagRuleT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("template")) {
      t.template = this.template();
    }
    if (fieldSet.has("active_when")) {
      t.activeWhen = this.activeWhen();
    }
    if (fieldSet.has("values")) {
      t.values = this.bb!.createScalarList<bigint>(this.values.bind(this), this.valuesLength());
    }
    if (fieldSet.has("valid_values")) {
      t.validValues = this.bb!.createScalarList<bigint>(
        this.validValues.bind(this),
        this.validValuesLength(),
      );
    }
    return t;
  }
}

export class FlagRuleT implements flatbuffers.IGeneratedObject {
  constructor(
    public template: number = 0,
    public activeWhen: ActiveWhen = ActiveWhen.NonZero,
    public values: bigint[] = [],
    public validValues: bigint[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const values = FlagRule.createValuesVector(builder, this.values);
    const validValues = FlagRule.createValidValuesVector(builder, this.validValues);

    return FlagRule.createFlagRule(builder, this.template, this.activeWhen, values, validValues);
  }

  clone(): FlagRuleT {
    const obj = new FlagRuleT();
    obj.template = this.template;
    obj.activeWhen = this.activeWhen;
    obj.values = [...this.values];
    obj.validValues = [...this.validValues];
    return obj;
  }

  equals(other: FlagRuleT): boolean {
    if (this.template !== other.template) return false;
    if (this.activeWhen !== other.activeWhen) return false;
    if (this.values.length !== other.values.length) return false;
    for (let i = 0; i < this.values.length; i++) {
      if (this.values[i] !== other.values[i]) return false;
    }
    if (this.validValues.length !== other.validValues.length) return false;
    for (let i = 0; i < this.validValues.length; i++) {
      if (this.validValues[i] !== other.validValues[i]) return false;
    }
    return true;
  }
}

export function verifyFlagRule(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
    verifier.checkScalarField(tablePos, 6, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkVector(pos, 8);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkVector(pos, 8);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
